import Cookies from 'js-cookie'

export async function fetchWrapper(path, args = {}) {
  const homeURL =
    window?.dataWP?.config?.endpoints?.home_url || process.env.REACT_APP_HOME_URL
  const jwt = Cookies.get('jwt')
  const nonce = window?.dataWP?.config?.wpnonce
  const { method = 'GET', headers = {}, body = '' } = args
  const url = new URL(path, homeURL)

  headers['Content-Type'] = 'application/json'

  if (jwt) {
    headers['Authorization'] = 'Bearer ' + jwt
  }

  if (!jwt && nonce) {
    url.searchParams.append('_wpnonce', nonce)
  }

  const fetchArgs = { method, headers }

  if (body) {
    fetchArgs.body = body
  }

  return fetch(url, fetchArgs)
}
